import { Checkbox } from '@digdir/designsystemet-react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CardContentWrapper } from '../../../../../solceller/form/components/styledComponents';
import { StyledCard } from '../../../../../../../../components/registering/steps/base/form/detailingSelect/components/styledComponents';
import { OppvarmingFormData } from '../../../../types';
import { useVedValidation } from '../useVedValidation';
import { InstallasjonsArRadio } from '../../../../../../components/installasjonsArRadio';

export const PeisMedDor = () => {
  const { register, watch, formState } = useFormContext<OppvarmingFormData>();
  const { validateVedSelection } = useVedValidation();
  const { t } = useTranslation();

  const peisMedDorSelected = watch('ved.value.peisMedDor.selected');

  return (
    <StyledCard isActive={peisMedDorSelected}>
      <CardContentWrapper>
        <Checkbox
          aria-invalid={!!formState.errors?.ved?.value?.peisMedDor?.selected}
          label={t('form.oppvarming.ved.peisMedDor.label')}
          {...register('ved.value.peisMedDor.selected', {
            validate: validateVedSelection,
            deps: ['ved.value.lukketOvn.selected', 'ved.value.apenPeis.selected'],
            shouldUnregister: true
          })}
        />
        {peisMedDorSelected && <InstallasjonsArRadio
          name={`ved.value.peisMedDor.value`}
          translationKeyPrefix={`form.oppvarming.ved.peisMedDor.installasjonsAr`}
        />}
      </CardContentWrapper>
    </StyledCard>
  );
};
